import request from "@/utils/request";

// 聊天室列表
export function getChatroomList(where) {
    return request.get("/business/chat", where);
}

// pc-查询讨论区列表
export function getChatroomListPC(where) {
    return request.get("/business/chat/pcPageList", where);
}

// 留言板内容管理
export function getLybList(where) {
    return request.get("/business/chat", where);
}

// 留言板内容详情
export function getLybDetail(where) {
    return request.get("/business/chat/msgs", where);
}

// 回复留言
export function hfMessage(where) {
    return request.post("/business/chat/speech", where);
}

// 操作留言
export function optMessage(where) {
    return request.post("/business/chat/opt", where);
}

// 聊天列表
export function getMessageDetail(where) {
    return request.get("/business/chat/msgs", where);
}

// 设置免打扰
export function mdrMessage(where) {
    return request.post("/business/chat/user/config", where);
}

// 更新用户信息
export function configUserInfo(where) {
    return request.post("/user/edit", where);
}

// 公告信息
export function getChatNotice(id) {
    return request.get("/business/notice", id);
}

// 聊天室验证码校验
export function validateColumnCode(where) {
    console.log('请求校验接口', where);
    return request.get("/business/chat/before", where);
}
// 聊天室历史会话列表
export function getChatHistoryConversations() {
    return request.get("/chat/history/conversations");
}
// 聊天室历史会话详情
export function getChatHistoryConversationDetail(conversationId) {
    return request.get(`/chat/history/conversation/${conversationId}`);
}
// 发起/继续聊天 (流式)
export function sendChatMessage(data) {
    return request({
        url: '/business/stock/chat/stream',
        method: 'post',
        data: data,
        responseType: 'stream', // Important for streaming response
        timeout: 0 // No timeout for stream
    });
}
// 删除聊天室历史会话
export function deleteChatHistoryConversation(conversationId) {
    return request.delete(`/chat/history/conversation/${conversationId}`);
}

